import { render, staticRenderFns } from "./citiesAndQuarters.vue?vue&type=template&id=10ec5ae1"
import script from "./citiesAndQuarters.vue?vue&type=script&lang=js"
export * from "./citiesAndQuarters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports